import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem("mk_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("mk_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

const existing = localStorage.getItem("mk_token");
if (existing) api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;

// Short-lived (5 min) credential for <img>/<a> URLs that can't carry an Authorization header. Refreshed in the
// background while signed in; the long-lived session token never goes into a URL.
let _dl = { token: "", at: 0 };
export const dlToken = () => (Date.now() - _dl.at < 4 * 60 * 1000 ? _dl.token : "");
export async function refreshDownloadToken() {
  try {
    const { data } = await api.get("/auth/download-token");
    _dl = { token: data.token, at: Date.now() };
  } catch { _dl = { token: "", at: 0 }; }
  return _dl.token;
}
export const withDl = (url) => { const t = dlToken(); return t ? `${url}${url.includes("?") ? "&" : "?"}t=${t}` : url; };

export const isSandbox = () => localStorage.getItem("mk_sandbox") === "1";
export const sandboxHeaders = () => (isSandbox() ? { "X-Sandbox": "1" } : {});
export function setSandboxMode(on) {
  if (on) {
    localStorage.setItem("mk_sandbox", "1");
    api.defaults.headers.common["X-Sandbox"] = "1";
  } else {
    localStorage.removeItem("mk_sandbox");
    delete api.defaults.headers.common["X-Sandbox"];
  }
}
if (isSandbox()) api.defaults.headers.common["X-Sandbox"] = "1";

export const CURRENCIES = {
  GBP: { symbol: "£", rate: 1, locale: "en-GB", code: "GBP", label: "GBP £" },
  USD: { symbol: "$", rate: 1.27, locale: "en-US", code: "USD", label: "USD $" },
  EUR: { symbol: "€", rate: 1.17, locale: "de-DE", code: "EUR", label: "EUR €" },
};

let _currency = (typeof localStorage !== "undefined" && localStorage.getItem("mk_currency")) || "GBP";
if (!CURRENCIES[_currency]) _currency = "GBP";

export function setDisplayCurrency(code) {
  if (CURRENCIES[code]) {
    _currency = code;
    try { localStorage.setItem("mk_currency", code); } catch (e) {}
  }
}
export function getDisplayCurrency() { return _currency; }

export function gbp(n) {
  const c = CURRENCIES[_currency] || CURRENCIES.GBP;
  return new Intl.NumberFormat(c.locale, { style: "currency", currency: c.code }).format((n || 0) * c.rate);
}

export function gbpOnly(n) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n || 0);
}

const IMG_HOSTS = ["static.prod-images.emergentagent.com", "images.unsplash.com", "images.pexels.com"];
export function img(url, w = 480) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("/api/doc-preview/")) return `${url}?w=${w}`;
  try {
    if (IMG_HOSTS.includes(new URL(url).hostname)) return `${API}/img?u=${encodeURIComponent(url)}&w=${w}`;
  } catch (e) { /* relative or data URL */ }
  return url;
}


export function fileUrl(url) {
  if (!url || typeof url !== "string") return url;
  const i = url.indexOf("/api/files/");
  return i >= 0 ? `${BACKEND_URL}${url.slice(i)}` : url;
}

export const isImageFile = (name) => /\.(jpe?g|png|webp|heic|heif|gif|bmp)$/i.test(name || "");

export function apiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
